import { Link } from "react-router-dom";
import { Calculator, ArrowUpRight } from "lucide-react";
import { SITE, FOOTER_COMPANY_LINKS } from "../../config/site";
import { PAGE_LIST } from "../../config/pages";

export const Footer = () => (
  <footer className="border-t border-ink-line bg-ink-surface" data-testid="site-footer">
    <div className="mx-auto max-w-6xl px-6 py-16 sm:py-20">
      <div className="grid gap-12 md:grid-cols-[minmax(0,2fr)_minmax(0,1fr)_minmax(0,1fr)]">
        <div>
          <Link to="/" className="flex items-center gap-2.5" data-testid="footer-logo">
            <span className="flex h-8 w-8 items-center justify-center bg-accent">
              <Calculator className="h-4.5 w-4.5 text-[#0B0B0B]" strokeWidth={2.5} />
            </span>
            <span className="font-display text-lg uppercase tracking-tight text-ink-text">
              MatCalc<span className="text-accent">360</span>
            </span>
          </Link>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-ink-muted">
            {SITE.tagline} Free, fast material takeoffs for roofing, concrete, asphalt, decking, drywall and every trade in between.
          </p>
          <a
            href={SITE.appBaseUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-app-link"
            className="mt-6 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-accent transition-colors duration-200 hover:text-accent-dark"
          >
            Open the full app
            <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>

        <div data-testid="footer-calculators">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-ink-muted">Calculators</p>
          <ul className="mt-5 space-y-3">
            {PAGE_LIST.map((page) => (
              <li key={page.slug}>
                <Link
                  to={`/${page.slug}`}
                  data-testid={`footer-link-${page.slug}`}
                  className="text-sm text-ink-text transition-colors duration-200 hover:text-accent"
                >
                  {page.calculator.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div data-testid="footer-company">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-ink-muted">Company</p>
          <ul className="mt-5 space-y-3">
            {FOOTER_COMPANY_LINKS.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-ink-text transition-colors duration-200 hover:text-accent"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-ink-line pt-8 sm:flex-row sm:items-center">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-ink-muted" data-testid="footer-copyright">
          © 2026 MatCalc360. All rights reserved.
        </p>
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-ink-muted">
          Measure twice. Calculate once.
        </p>
      </div>
    </div>
  </footer>
);
